export default __webpack_public_path__ + "static/media/thumbs-up-facebook.2cba0486.svg";